import { useEffect } from 'react'
import { form } from '../../../formState'

export function useConnectedToBackOfficePhone() {
  const formApi = form.useFormApi()
  const callbackConfigStatus = form.useFormField('callbackConfigStatus')
  const status = form.useFormField('status')
  const statusValue = status.field.value
  const callbackConfigStatusValue = callbackConfigStatus.field.value

  useEffect(() => {
    if (statusValue !== 'ADVANCED') {
      formApi.setFieldVisibleState('backOfficePhone', false)
      formApi.setFieldVisibleState('automatedMessageEnabled', false)
      formApi.setFieldVisibleState('automatedMessage', false)
      formApi.setFieldVisibleState('automatedMessageVoice', false)
      formApi.clearError('backOfficePhone')
      formApi.clearError('automatedMessage')
    } else if (callbackConfigStatusValue === 'OFF') {
      formApi.setFieldVisibleState('backOfficePhone', false)
      formApi.setFieldVisibleState('automatedMessageEnabled', true)
      formApi.setFieldVisibleState('automatedMessage', true)
      formApi.setFieldVisibleState('automatedMessageVoice', true)
      formApi.clearError('backOfficePhone')
    } else {
      formApi.setFieldVisibleState('backOfficePhone', true)
      formApi.setFieldVisibleState('automatedMessageEnabled', false)
      formApi.setFieldVisibleState('automatedMessage', false)
      formApi.setFieldVisibleState('automatedMessageVoice', false)
      formApi.clearError('automatedMessage')
    }
  }, [callbackConfigStatusValue, formApi, statusValue])
}
